import React from "react";
import { useTranslation } from "react-i18next";

/** Full-screen confirmation shown after payment is detected, before any redirect. */
export function PaymentIdentifiedScreen({ subtitle }: { subtitle?: string }) {
  const { t } = useTranslation();
  return (
    <main className="min-h-screen surface-aurora flex items-center justify-center p-4">
      <div className="card-glass max-w-md w-full p-8 text-center text-[color:var(--text-primary)]">
        <div className="text-2xl font-semibold mb-3">{t("paymentIdentified.title")}</div>
        <p className="text-sm text-ink-2 leading-relaxed">{subtitle ?? t("paymentIdentified.redirecting")}</p>
      </div>
    </main>
  );
}
